import { render } from "./AiMarkdown.vue?vue&type=template&id=27dac142&scoped=true"
import script from "./AiMarkdown.vue?vue&type=script&lang=js"
export * from "./AiMarkdown.vue?vue&type=script&lang=js"

import "./AiMarkdown.vue?vue&type=style&index=0&id=27dac142&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-27dac142"]])

export default __exports__